export default {"src":"/_next/static/media/suzuki.e1952472.svg","height":800,"width":1200,"blurWidth":0,"blurHeight":0};